/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { localStorageSingleton } from '@zcode/nr-utils'

export const addForYouTokens = (search: string) => {
  localStorageSingleton.setx('forYouTokens', search)
}
